import { query2BOrders, query2COrders } from "@/apis/cube/order";
import {
  detailIntegrationOrder,
  getIntegrationOrderTMSProductUsage,
} from "@/apis/integration/order";
import {
  Cube2BOrder,
  Cube2COrder,
  IntegrationOrderType,
  TMSOrderVCInfo,
  TMSOrderVCType,
} from "@/types";
import { useQuery } from "@tanstack/react-query";
import { withDefault } from "use-query-params";
import { StringParam } from "use-query-params";

export const PageQueryConfig = {
  includePagination: false,
  defaultQuery: {
    cubeOrderId: withDefault(StringParam, ""),
    type: withDefault(StringParam, ""),
  },
};

async function getCubeOrderDetail(
  customerNumber: string | undefined,
  type: IntegrationOrderType
): Promise<Cube2COrder | Cube2BOrder | null> {
  if (!customerNumber) {
    return Promise.resolve(null);
  }
  if (type === IntegrationOrderType.Customer) {
    return query2COrders({ theThirdNumber: customerNumber }).then((res) => {
      if (res.items.length > 0) {
        return res.items[0];
      }
      return null;
    });
  } else if (type === IntegrationOrderType.Business) {
    return query2BOrders({ customerNumber }).then((res) => {
      if (res.items.length > 0) {
        return res.items[0];
      }
      return null;
    });
  }
  return Promise.resolve(null);
}

export function useCubeOrderDetail(
  customerNumber: string | undefined,
  type: IntegrationOrderType
) {
  return useQuery({
    queryKey: ["cube-order-detail", type, customerNumber],
    queryFn: () => getCubeOrderDetail(customerNumber, type),
    refetchOnWindowFocus: false,
    retry: false,
  });
}

export function useIntegrationOrderProductUsage(orderId: string) {
  return useQuery({
    queryKey: ["integration-order-product-usage", orderId],
    queryFn: () => getIntegrationOrderTMSProductUsage(orderId),
    initialData: {},
  });
}

export function useIntegrationOrder(id?: string) {
  return useQuery({
    queryKey: ["integration-order", id],
    queryFn: () => (id ? detailIntegrationOrder(id) : null),
    retry: false,
    enabled: !!id,
    refetchOnWindowFocus: false,
    placeholderData: (previousData) => previousData,
  });
}

export const DefaultVCInfo: TMSOrderVCInfo = {
  type: TMSOrderVCType.Amazon,
  carrierName: "",
  bolNo: "",
  proNo: "",
  arnNo: "",
  poNo: "",
};
